
import { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import CompanyIntro from './components/CompanyIntro';
import ArtistIntro from './components/ArtistIntro';
import Services from './components/Services';
import Reviews from './components/Reviews';
import Booking from './components/Booking';
import Location from './components/Location';
import Social from './components/Social';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  const [activeFilter, setActiveFilter] = useState('전체');

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <CompanyIntro />
        <ArtistIntro />
        <Services activeFilter={activeFilter} setActiveFilter={setActiveFilter} />
        <Reviews />
        <Booking />
        <Location />
        <Social />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
